<template>
    <div class="features-root">
        <div class="features-header">
            <h2 class="features-title">Four Core Value Drivers of the Platform</h2>
            <div class="features-subtitle">Scalable Platform Capabilities</div>
        </div>

        <div class="features-box">
            <!-- <div class="features-bg"></div> -->
            <div class="features-content">
                <div class="features-cards">
                    <div class="feature-card">
                        <div class="card-icon pc-only" style="color: #ff8e53; background-color: #fff5ed">
                            <img src="@/assets/home-grid-1.png" class="cta-icon-img" alt="SmartRewards" />
                        </div>
                        <div class="card-title">
                            Participation-Based Benefits
                            <div class="card-underline h5-only"></div>
                        </div>
                        <div class="card-desc">Certain platform benefits may be granted based on user activity and participation.<br class="pc-only" />These benefits are not purchased, have no cash value, and cannot be exchanged for money.</div>
                    </div>
                    <div class="feature-card">
                        <div class="card-icon pc-only" style="color: #4b8df8; background-color: #f0f5ff">
                            <img src="@/assets/home-grid-2.png" class="cta-icon-img" alt="SmartRewards" />
                        </div>
                        <div class="card-title">
                            Content Discovery System
                            <div class="card-underline h5-only"></div>
                        </div>
                        <div class="card-desc">Platform mechanisms that help listings reach interested users based on relevance, activity signals, and user preferences.</div>
                    </div>
                    <div class="feature-card">
                        <div class="card-icon pc-only" style="color: #ff5e62; background-color: #fff0f1">
                            <img src="@/assets/home-grid-3.png" class="cta-icon-img" alt="SmartRewards" />
                        </div>
                        <div class="card-title">
                            Optional Platform Features
                            <div class="card-underline h5-only"></div>
                        </div>
                        <div class="card-desc">
                            The platform provides optional feature <br class="pc-only" />
                            configurations to support different usage scenarios.<br class="pc-only" />Some features may require separate activation and are subject to applicable policies.
                        </div>
                    </div>
                    <div class="feature-card">
                        <div class="card-icon pc-only" style="color: #f7b731; background-color: #fffbf0">
                            <img src="@/assets/home-grid-4.png" class="cta-icon-img" alt="SmartRewards" />
                        </div>
                        <div class="card-title">
                            Trust & Reputation Framework
                            <div class="card-underline h5-only"></div>
                        </div>
                        <div class="card-desc">
                            User reputation indicators are calculated <br class="pc-only" />
                            based on transaction history,<br class="pc-only" />community behavior, and account activity. This system <br class="pc-only" />
                            is non-financial and does not represent credit or monetary value.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Features'
}
</script>

<style scoped>
.features-root {
    position: relative;
    width: 100%;
    padding-bottom: 40px;
    /* background: #fff; */
    overflow: hidden;
    overflow-x: hidden;
}
.features-header {
    padding: 0 20px;
    margin-top: 124px;
    margin-bottom: 51px;
}
.features-title,
/* .card-title, */
.features-subtitle {
    font-family: 'Sansita', Arial, sans-serif !important;
}
.features-title {
    color: #222;
    font-size: 2.2rem;
    font-family: 'Poppins', 'Montserrat', Arial, sans-serif;
    font-weight: 800;
    text-align: center;
    margin-bottom: 8px;
}
.features-subtitle {
    color: #888;
    font-size: 1.1rem;
    text-align: center;
    margin-bottom: 24px;
    text-transform: uppercase;
    letter-spacing: 1px;
}
.features-box {
    position: relative;
    margin: 0 40px;
    border-radius: 24px;
    height: 915px;
    width: 1384px;
    background: url('@/assets/bg_middle.png') center/cover no-repeat;
    padding: 38px 40px 56px 40px;

    margin: 0 auto;
}
.features-bg {
    /* position: absolute;
    inset: 0;
    z-index: 1;
    border-radius: 24px; */
}
.features-content {
    /* position: relative;
    z-index: 2;
    
    width: 100%;
    box-sizing: border-box; */
}

.features-cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 40px;
    column-gap: 65px;
    margin-bottom: 32px;
    width: 100%;
}
.feature-card {
    position: relative;
    width: 619px;
    height: 390px;
    background: #fff url('@/assets/home-grid.png') no-repeat;
    background-size: 50%;
    background-position: right -1% top -25%;
    opacity: 1;
    border-radius: 22px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    padding: 30px 20px 40px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow: hidden;
    text-decoration: none;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.feature-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
}

.cards-ww {
    width: 110px;
}

.card-icon {
    width: 106px;
    height: 106px;
    margin-bottom: 24px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
}
.card-icon svg {
    width: 44px;
    height: 44px;
}
.card-title {
    font-size: 36px;
    font-weight: 700;
    line-height: 50.4px;
    font-family: 'Poppins', sans-serif;
    margin-bottom: 28px;
    z-index: 1;
    color: #222;
}

.card-desc {
    font-family: 'Poppins Light', sans-serif;
    color: #9b9ca5;
    font-size: 16px;
    line-height: 26.24px;
    font-weight: 300;
    z-index: 1;
}

.h5-only {
    display: none !important;
}
.pc-only {
    display: block;
}
.cta-icon-img {
    height: 44px;
    width: auto;
    vertical-align: middle;
}

@media (max-width: 900px) {
    .features-root {
        margin-top: 16px;
        padding-bottom: 16px;
    }
    .features-header {
        margin-top: 10px;
        margin-bottom: 12px;
    }
    .features-title {
        font-size: 16px;
        margin-bottom: 4px;
    }
    .features-subtitle {
        font-size: 10px;
        margin-bottom: 16px;
    }
    .features-box {
        margin: 0 12px;
        min-height: auto;
        height: auto;
        width: auto;
        padding: 20px 10px;
        box-sizing: border-box;
        background-position: center;
        background-size: cover;
    }
    .features-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .features-cards {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        align-items: stretch;
        justify-content: space-between;
        margin-bottom: 0;
        width: 100%;
    }
    .feature-card {
        width: 100%;
        padding: 11px 11px;
        border-radius: 16px;
        background-size: 50%;
        background-position: right -1% top 5%;
        height: 103px;
    }

    .card-title {
        font-size: 9px;
        margin-bottom: 8px;
        font-weight: 800;
        line-height: 1.3;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .card-desc {
        font-size: 7px;
        line-height: 1.5;
        color: #999;
    }

    .card-underline {
        width: 14px;
        height: 0;
        border-bottom: 2px solid #ff5e62;
        margin-top: 6px;
        flex-shrink: 0;
    }

    .pc-only {
        display: none !important;
    }
    .h5-only {
        display: block !important;
    }
}
@media (max-width: 300px) {
    .features-cards {
        gap: 6px;
    }
    .feature-card {
        width: 100%;
        min-height: 120px;
    }
}
</style>
